import React from 'react'
import { Container, Table } from 'react-bootstrap'

export const ListSkeleton = ({ tableHeader, columnLength }) => {
    return (
        <>
            {tableHeader}
            <tbody style={{ textAlign: "start" }}>
                {Array.from({ length: columnLength }).map((_, rowIndex) => (
                    <tr
                        key={rowIndex}
                        style={{ marginTop: "10px", marginBottom: "10px" }}
                    >
                        {Array.from({ length: columnLength + 1 }).map((_, colIndex) => (
                            <td key={colIndex}>
                                <div
                                    style={{
                                        height: "20px",
                                        backgroundColor: "#e0e0e0",
                                        borderRadius: "4px",
                                        animation: "pulse 1.5s ease-in-out infinite",
                                        width:
                                            colIndex === 0
                                                ? "30px"
                                                : colIndex === 1
                                                    ? "120px"
                                                    : "80px",
                                    }}
                                ></div>
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </>
    )
}
